import { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import TubeGeneratorPage from './TubeGeneratorPage';
import Header from './Header';
import PasswordPrompt from './PasswordPrompt';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check sessionStorage when page loads
    const auth = sessionStorage.getItem("tube-auth");
    if (auth === "true") {
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <div>
          <Header />
      {!isAuthenticated ? (
        <PasswordPrompt onSuccess={() => setIsAuthenticated(true)} />
      ) : (
        <>
          <TubeGeneratorPage />
        </>
      )}
    </div>
  );
}

export default App;
